import { render, staticRenderFns } from "./continue.vue?vue&type=template&id=71942712&scoped=true"
import script from "./continue.vue?vue&type=script&lang=js"
export * from "./continue.vue?vue&type=script&lang=js"
import style0 from "./continue.vue?vue&type=style&index=0&id=71942712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71942712",
  null
  
)

export default component.exports